module.exports = __webpack_public_path__ + "img/s-register.b1768671.svg";